export * from './lib/ui-restricted-splash';
